<template>
  <v-dialog v-bind="$attrs" scrollable :width="width" @update:model-value="$emit('update:model-value', $event)">
    <template v-slot:activator="activatorProps">
      <slot name="activator" v-bind="activatorProps" />
    </template>

    <v-card :color="color">
      <v-card-title
        class="d-flex overflow-force-visible qtm-h3 text-secondary"
        :class="titleClasses"
      >
        <div :class="{ 'header-section': $slots['title-center'] }">
          <span>
            <slot name="title">
              {{ title }}
            </slot>
          </span>
        </div>
        <div v-if="$slots['title-center']" class="header-section">
          <span>
            <slot name="title-center" />
          </span>
        </div>
        <div class="header-section">
          <span class="mr-n3 mt-n4">
            <slot name="close" :props="{ onClick: () => $emit('update:model-value', false) }">
              <qtm-icon-btn
                v-if="closable"
                color="mid-light-grey"
                density="compact"
                icon="mdi-close"
                @click="$emit('update:model-value', false)"
              />
            </slot>
          </span>
        </div>
      </v-card-title>
      <v-card-subtitle class="overflow-force-visible text-mid-grey" :class="subtitleClasses">
        <slot name="subtitle">
          {{ subtitle }}
        </slot>
      </v-card-subtitle>
      <v-card-text class="pt-0 text-mid-dark-grey" :class="`pb-${paddingBottom} px-${padding}`">
        <slot />
      </v-card-text>
      <v-card-actions v-if="$slots.actions" class="bg-white" :class="`px-${padding} ${actionsClass}`">
        <slot name="actions" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
export interface Props {
  actionsClass?: string
  closable?: boolean
  color?: string
  padding?: number | string
  paddingBottom?: number | string
  subtitle?: string
  title?: string
  titleClass?: string
  headerBackground?: string
  width?: number | string
}
const props = withDefaults(defineProps<Props>(), {
  actionsClass: '',
  closable: false,
  color: 'background',
  padding: 6,
  paddingBottom: 6,
  subtitle: '',
  title: '',
  titleClass: undefined,
  headerBackground: 'background',
  width: 400
})
defineEmits(['update:model-value'])

const titleClasses = computed(() => {
  const classes = [props.titleClass]
  if (props.padding) {
    classes.push(`pa-${props.padding}`)
  }
  if (props.headerBackground) {
    classes.push(`bg-${props.headerBackground}`)
  }
  return classes
})
const subtitleClasses = computed(() => {
  const classes = []
  if (props.padding) {
    classes.push(`px-${props.padding}`)
  }
  if (props.headerBackground) {
    classes.push(`bg-${props.headerBackground}`)
  }
  return classes
})
</script>

<style lang="scss" scoped>
.header-section {
  display: flex;
  flex: 1;
  justify-content: center;
}

.header-section:first-child > span {
  margin-right: auto;
}

.header-section:last-child > span {
  margin-left: auto;
}
</style>
